export var SupplierTransactionType;
(function (SupplierTransactionType) {
    SupplierTransactionType[SupplierTransactionType["Unknown"] = 0] = "Unknown";
    SupplierTransactionType[SupplierTransactionType["Payment"] = 1] = "Payment";
    SupplierTransactionType[SupplierTransactionType["Invoice"] = 2] = "Invoice";
    SupplierTransactionType[SupplierTransactionType["Refund"] = 3] = "Refund";
    SupplierTransactionType[SupplierTransactionType["Cancellation"] = 4] = "Cancellation";
})(SupplierTransactionType || (SupplierTransactionType = {}));
